import { useContext, useEffect } from 'react';
import { useMutation, useQuery } from 'react-query';
import { ApiContext } from '../App';
import { AuthContext } from '../App';
import { UserContext } from '../App';
import UserRecord from '../records/user';

const options = {
  retry: false
}

export const useCreateAuthToken = () => {
  const api = useContext(ApiContext);

  return useMutation(user => api.post('/auth', user), {
    onError: error => console.log(error)
  });
}

export const useGetAuth = token => {
  const api = useContext(ApiContext);

  return useQuery('auth', () => api.get(`/auth/${token}`), options);
}

export const useSetAuth = data => {
  const auth = useContext(AuthContext);
  const user = useContext(UserContext);

  useEffect(() => {
    if (!auth.auth && data?.data && !user.user.id) {
      auth.setAuth(data.data.data);
      user.setUser(new UserRecord({ ...data.data.data.attributes, is_logged_in: true }));
      window.localStorage.setItem('auth', JSON.stringify(data));
    } else if (!auth.auth && data?.data && user.user.id) {
      auth.setAuth(data.data.data);
    }
  }, [data, user.user]);
}

export const useHydrateAuth = () => {
  const saved = JSON.parse(window.localStorage.getItem('auth'));

  useSetAuth(saved);

  return saved;
}
